import { CuredApiPaths } from '../../models/enums';
import { UseMutationOptions } from '@tanstack/react-query';
import { ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';
import { stringifyUrl } from 'query-string';
import { isRootFolder } from 'utils/folders';

const useDeleteVoiceContent = (
    voiceContentId: string,
    parentFolderId?: number,
    mutateOptions?: UseMutationOptions<unknown, Error>
) => {
    const url = stringifyUrl({
        url: `${CuredApiPaths.VOICE_CONTENT}/${voiceContentId}`,
        query: { ...(parentFolderId && !isRootFolder(parentFolderId) && { parentFolderId: parentFolderId }) },
    });
    return useMutation(MutationKeys.DELETE_VOICE_CONTENT, url, mutateOptions, ApiMethods.DELETE);
};

export default useDeleteVoiceContent;
